<template>
  <v-container class="mt-2 px-0">
    <v-card
      class="px-2 pb-6">
      <v-row>
        <v-col cols="9">
          <p>Regra de Aceitação - Listar</p>
        </v-col>
        <v-col cols="3" class="d-flex flex-row justify-end">
          <v-btn small @click="edit" v-if="selected.length == 1" class="mr-1">
            <v-icon small title="Editar">fas fa-edit</v-icon>
          </v-btn>
          <v-btn small @click="removeAll" v-if="selected.length" class="mr-1">
            <v-icon small title="Remover Selecionados">fas fa-trash</v-icon>
          </v-btn>
          <v-btn small @click="create" class="mr-1">
            <v-icon small title="Criar">fas fa-plus</v-icon>
          </v-btn>
          <v-btn small @click="findAll">
            <v-icon small title="Buscar">fas fa-search</v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <v-divider class="mb-4"></v-divider>

      <v-row>
        <v-col cols="6">
          <v-text-field
            dense
            label="Código"
            type="number"
            min="0"
            v-model="acceptanceRule.code"
            outlined
          />
        </v-col>
        <v-col cols="6">
          <v-text-field
            dense
            label="Descrição"
            type="text"
            min="0"
            v-model="acceptanceRule.description"
            outlined
          />
        </v-col>
        <v-col cols="4">
          <v-text-field
            dense
            label="Mínimo de vidas"
            type="number"
            min="0"
            v-model="acceptanceRule.minimumLives"
            outlined
          />
        </v-col>
        <v-col cols="4">
          <v-text-field
            dense
            label="Máximo de vidas"
            type="number"
            min="0"
            v-model="acceptanceRule.maximumLives"
            outlined
          />
        </v-col>
        <v-col cols="4">
          <v-checkbox
            dense
            label="Selecionar Inativos"
            v-model="acceptanceRule.active"
            :true-value="false"
            :false-value="true"
            outlined
          />
        </v-col>
      </v-row>

      <v-container fluid v-if="itemsTotal">
        <v-row>
          <v-col cols="12">
            <v-data-table
              v-model="selected"
              :headers="headers"
              :items="items"
              :options.sync="options"
              :server-items-length="itemsTotal"
              item-key="id"
              locale="pt-BR"
              show-select
              class="elevation-1 mt-2"
              @click:row="show"
            >
              <template v-slot:item.active="{item}">
                {{ item.active ? 'Sim' : 'Não' }}
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-container>
      <DlgConfirmCancel ref="confirm"></DlgConfirmCancel>
    </v-card>
  </v-container>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from 'vuex';
import DlgConfirmCancel from '@/components/dlg-confirm_cancel.vue';
import XippAuthService from "@/services/auth/XippAuthService";

export default {
  components: {DlgConfirmCancel},
  data() {
    return {
      acceptanceRule: {
        code: null,
        description: null,
        minimumLives: null,
        maximumLives: null,
        active: true,
      },
      headers: [
        {text: 'Código', align: 'end', value: 'code'},
        {text: 'Descrição', align: 'left', value: 'description'},
        {text: 'Mínimo de Vidas', align: 'end', value: 'minimumLives'},
        {text: 'Máximo de Vidas', align: 'end', value: 'maximumLives'},
        {text: 'Ativos', align: 'center', value: 'active'},
      ],
      options: {},
      items: [],
      itemsTotal: null,
      singleSelect: false,
      selected: [],
      loading: true,
    };
  },
  beforeCreate() {
    this._xippAuthService = new XippAuthService();
  },
  async created() {
    const sessionKey = "access_token";

    const {token} = this.$route.query;
    if (token) {
      try {
        localStorage.setItem(sessionKey, this.$route.query.token);
        this.toogleDialogLoading(this.loading);
        await this._xippAuthService.GetTokenFull()
          .then((response) => {
            if(response && response.data) {
              localStorage.setItem(sessionKey, response.data.token);
            }
          })
          .finally(() => {
            this.loading = false;
            this.toogleDialogLoading(this.loading);
          });
      } catch (e) {
        this.loading = false;
        this.toogleDialogLoading(this.loading);
        console.log(e)
      }
    }
  },
  watch: {
    options: {
      handler() {
        this.findAll();
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters('acceptanceRule', [
      'acceptanceRuleProcessed',
      'getAcceptanceRules',
    ]),
  },
  methods: {
    ...mapActions('acceptanceRule', [
      'deleteAcceptanceRule',
      'fetchAcceptanceRules',
    ]),
    ...mapMutations(['toogleDialogLoading']),
    findAll() {
      const {sortBy, sortDesc, page, itemsPerPage} = this.options;
      this.toogleDialogLoading(true);

      this.fetchAcceptanceRules(
        Object.assign(this.acceptanceRule, {
          page: page ? page - 1 : 0,
          sortBy: sortBy && sortBy.length ? sortBy[0] : 'code',
          descending: sortDesc && sortDesc.length ? sortDesc[0] : false,
          size: itemsPerPage,
        }),
      )
        .then((data) => {
          this.items = data.content;
          this.itemsTotal = data.totalElements;
        })
        .finally(() => {
          this.toogleDialogLoading(false);
        });
    },
    async removeAll() {
      this.toogleDialogLoading(true);
      if (
        this.selected.length &&
        (await this.$refs.confirm.show(
          'Atenção',
          'Deseja excluir os registros selecionados?',
        ))
      ) {
        for (const acceptanceRule of this.selected) {
          await this.deleteAcceptanceRule(acceptanceRule.id);
        }
        this.findAll();
      } else {
        this.toogleDialogLoading(false);
      }
    },
    edit() {
      this.$router.push(`/acceptance_rule/${this.selected[0].id}/edit`);
    },
    create() {
      this.$router.push('/acceptance_rule/new');
    },
    show(value) {
      this.$router.push(`/acceptance_rule/${value.id}/show`);
    },
  },
};
</script>


